import { render, staticRenderFns } from "./sosPosition.vue?vue&type=template&id=03dbc34c&scoped=true"
import script from "./sosPosition.vue?vue&type=script&lang=js"
export * from "./sosPosition.vue?vue&type=script&lang=js"
import style0 from "./sosPosition.vue?vue&type=style&index=0&id=03dbc34c&prod&lang=css"
import style1 from "./sosPosition.vue?vue&type=style&index=1&id=03dbc34c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03dbc34c",
  null
  
)

export default component.exports